import React, { memo, useMemo } from 'react'

import ChartArea from 'components/ChartArea/ChartArea'
import {
  getConsamptionDataTimeStampSelector,
  getConsamptionDataIdsSelector,
  getColorForChartIfSelectedDeviceFilter,
} from 'redux/reducers/equipments'
import { useShallowEqualSelector } from 'custom-hooks'
import { useEquipmentContext } from '../EquipmentContainer'

const chartsConstants = {
  chartId: 'equipment_consamption_chart',
}

const ChartSection = () => {
  const _x = useShallowEqualSelector(getConsamptionDataTimeStampSelector)

  const _yIds = useShallowEqualSelector(getConsamptionDataIdsSelector)

  const deviceColor = useShallowEqualSelector(
    getColorForChartIfSelectedDeviceFilter
  )

  const { selectedDevices } = useEquipmentContext()

  const _seriesY = useMemo(
    () =>
      selectedDevices.map((d) => ({
        name: `kWh|${d.name}`,
        type: 'area',
        color: deviceColor || d.color,
        data: _yIds[d.id],
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [_yIds, selectedDevices]
  )

  return (
    <ChartArea
      className="equipment_charts"
      categoriesX={_x}
      seriesY={_seriesY}
      id={chartsConstants.chartId}
      isFetching={false}
    />
  )
}

export default memo(ChartSection)
